import {Trans} from '@lingui/macro';
import React, {useMemo} from 'react';
import styled from 'styled-components';

import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';
import {openInBrowser} from '../../../../../../srcCommon/browser/openInBrowser';
import {InlineBanner, InlineBannerTypesEnum} from '../../../../../components/inlineBanner/inlineBanner';

/*
 * Props.
 */

interface CsatEditorBannerProps {}

/*
 * Styles.
 */

const StyledInlineBanner = styled(InlineBanner)`
  width: 530px;
  margin-bottom: 20px;
`;

/*
 * Component.
 */

export const CsatEditorBanner: React.FC<CsatEditorBannerProps> = (props) => {
  const bannerActions = useMemo(
    () => [
      {
        title: <Trans id="csat-editor-banner-action">Learn more</Trans>,
        onClick: () => openInBrowser('https://help.frontapp.com/t/p8hf16d/fronts-csat-feature'),
        id: 'learn-more-action',
      },
    ],
    [],
  );

  return (
    <StyledInlineBanner
      type={InlineBannerTypesEnum.INFO}
      title={
        <Trans id="csat-editor-banner-title">This rule sends a CSAT Message Template automatically</Trans>
      }
      size={VisualSizesEnum.MEDIUM}
      actions={bannerActions}
    >
      <Trans id="csat-editor-banner-content">
        Before beginning, make sure you&apos;ve created one using Message Templates.
      </Trans>
    </StyledInlineBanner>
  );
};
